import { Outlet } from "react-router-dom";
import { useAppAbility } from "@/casl";
import { Restricted } from "@/components/pages";
import { ContractPricingProfilesContextProvider } from "./ContractPricingProfilesContext";

export const ContractPricingProfilesRoute = () => {
  const ability = useAppAbility();

  if (!ability.can("manage", "providerConfigPricingFixed")) return (
    <div className="flex flex-1 flex-col min-h-[calc(100vh-120px)] px-5 py-4">
      <Restricted />
    </div>
  );

  return (
    <ContractPricingProfilesContextProvider>
      <Outlet />
    </ContractPricingProfilesContextProvider>
  );
};